import axiosInstance from "../config/axiosInstance";

const BASE_URL = "/securityrole";

/**
 * Obtiene una lista paginada de roles de seguridad.
 * Evita enviar "null" como string en el parámetro de búsqueda.
 *
 * @param {number} pageIndex - Número de página (por defecto 1)
 * @param {number} pageSize - Tamaño de la página (por defecto 10)
 * @param {string|null} searchTerm - Término de búsqueda (opcional)
 * @returns {Promise<ApiResponse<PaginatedResult<SecurityRoleDto>>>}
 */
export const getPagedRoles = async (
  pageIndex = 1,
  pageSize = 10,
  searchTerm = null
) => {
  const params = {
    pageIndex,
    pageSize,
  };

  if (searchTerm && searchTerm.trim() !== "") {
    params.searchTerm = searchTerm.trim();
  }

  const response = await axiosInstance.get(`${BASE_URL}/paged`, {
    params,
  });

  return response.data;
};

/**
 * Obtiene un rol por su ID.
 * @param {Guid} id - ID del rol
 * @returns {Promise<ApiResponse<SecurityRoleDto>>}
 */
export const getRoleById = async (id) => {
  const response = await axiosInstance.get(`${BASE_URL}/${id}`);
  return response.data;
};

/**
 * Crea un nuevo rol de seguridad.
 * @param {CreateSecurityRoleDto} data - Datos para crear el rol
 * @returns {Promise<ApiResponse<SecurityRoleDto>>}
 */
export const createRole = async (data) => {
  const response = await axiosInstance.post(`${BASE_URL}`, data);
  return response.data;
};

/**
 * Actualiza un rol existente.
 * @param {UpdateSecurityRoleDto} data - Datos del rol actualizado (incluye ID)
 * @returns {Promise<ApiResponse<boolean>>}
 */
export const updateRole = async (data) => {
  const response = await axiosInstance.put(`${BASE_URL}/${data.id}`, data);
  return response.data;
};

/**
 * Elimina un rol de seguridad por su ID.
 * @param {Guid} id - ID del rol a eliminar
 * @returns {Promise<ApiResponse<boolean>>}
 */
export const deleteRole = async (id) => {
  const response = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return response.data;
};

/**
 * Obtiene los usuarios asociados a un rol específico.
 * @param {Guid} roleId - ID del rol
 * @returns {Promise<ApiResponse<SecurityUserDto[]>>}
 */
export const getUsersByRoleId = async (roleId) => {
  const response = await axiosInstance.get(`${BASE_URL}/${roleId}/users`);
  return response.data;
};
export const getAllRoles = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/all`);

  return res.data?.data ?? [];
};
